import { render, staticRenderFns } from "./IFDebtRiskVariance.vue?vue&type=template&id=754e0f76"
import script from "./IFDebtRiskVariance.vue?vue&type=script&lang=js"
export * from "./IFDebtRiskVariance.vue?vue&type=script&lang=js"
import style0 from "./IFDebtRiskVariance.vue?vue&type=style&index=0&id=754e0f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports